import { toast } from "react-toastify";

export const getErrorMessage = (e, fallback = "Something went wrong") => {
  const data = e?.response?.data;

  let msg =
    (Array.isArray(data?.message) ? data.message[0] : data?.message) ||
    data?.error ||
    e?.message ||
    fallback;

  // 🔥 Make messages user-friendly
  if (msg.toLowerCase().includes("already exists")) {
    return "This code is already in use. Please try a different one.";
  }

  if (msg.toLowerCase().includes("invalid")) {
    return "Some details are invalid. Please check and try again.";
  }

  if (msg.toLowerCase().includes("unauthorized")) {
    return "Your session has expired. Please login again.";
  }

  return msg;
};

export const showApiErrorToast = (e, fallback) => {
  toast.error(getErrorMessage(e, fallback));
};

export const showValidationToast = (errors, fallback = "Please fill all required fields correctly") => {
  const firstError = Object.values(errors || {}).find(Boolean);
  toast.error(firstError || fallback);
};

export const showSuccessToast = (message) => {
  toast.success(message);
};